<template>
	<div>
		<div class="form-row">
			<div class="form-group col-md-4">
		        <label>Cliente</label>
		        <select-two 
		        	:options="clientes" 
		        	:formId="name+'cliente_id'"
		        	:valueDefault="dados.cliente"
		        	@selected="setClienteId"
		        	@searching="getClientes"
		        	@noValue="setClienteId('')"
		        	arrayValue="nome">
		        </select-two>
		        <div class="invalid-feedback" :id="name+'cliente_id-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Data do Pedido</label>
		        <input 
		        	type="date" 
		        	class="form-control" 
		        	v-model="dados.data" 
		        	:id="name+'data'" 
		        	@input="clearValidation('data')">
		        <div class="invalid-feedback" :id="name+'data-invalid-feedback'"></div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Prazo</label>
		        <input 
		        	type="date" 
		        	class="form-control" 
		        	v-model="dados.prazo" 
		        	:id="name+'prazo'" 
		        	@input="clearValidation('prazo')">
		        <div class="invalid-feedback" :id="name+'prazo-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row" v-if="method == 'update'">
		    <div class="form-group col-md-12">
		        <label>Estágio *</label>
		        <select
		        	class="form-control" 
		        	v-model="dados.estagio_id" 
		        	:id="name+'estagio_id'" 
		        	@input="clearValidation('estagio_id')">
		        	<option 
		        		v-for="estagio of estagios"
		        		:value="estagio.id">
		        		{{ estagio.nome }}
		        	</option>
		        </select>
		        <div class="invalid-feedback" :id="name+'estagio_id-invalid-feedback'"></div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Descrição</label>
				<vue-editor v-model="dados.descricao"></vue-editor>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors', 'method'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				clientes: [],
				estagios: []
			}
		},
		created(){
			this.getDados();
		},
		methods : {
			getDados(){
				this.getClientes();
				this.getEstagio();
			},
			getClientes(pesquisa=''){
				axios.get(this.$url+'/api/adm/clientes/list?pesquisa='+pesquisa)
	            .then(response => {
	                this.clientes = response.data.data.data
	            })
			},
			setClienteId(valor){
				this.dados.cliente_id = (valor && valor.id) ? valor.id : null;
				this.clearValidation('cliente_id');
			},
			getEstagio(){
				axios.get(this.$url+'/api/adm/estagios')
	            .then(response => {
	                this.estagios = response.data
	            })
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            },
        }
    }
</script>
